export default __webpack_public_path__ + "static/media/Griefscale Helm.36b85b80.jpg";